import { create } from "zustand";

interface HomeState {
	currentHeroImageIndex: number;
	nextHeroImage: (totalImages: number) => void;
	setHeroImage: (index: number) => void;
}

export const useHomeStore = create<HomeState>()((set) => ({
	currentHeroImageIndex: 0,
	nextHeroImage: (totalImages) =>
		set((state) => ({
			currentHeroImageIndex: (state.currentHeroImageIndex + 1) % totalImages,
		})),
	setHeroImage: (index) => set({ currentHeroImageIndex: index }),
}));
